// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3yCU{width:100%;margin:0 auto 1.6rem;padding:1.6rem 2rem;background-color:#fff;display:flex;flex-direction:column;justify-content:space-between;box-shadow:0 .4rem .8rem 0 rgba(0,0,0,.08)}@media (min-width:48em){._3yCU{margin:0 0 3.2rem}}._3yCU .h2{margin:.8rem 0;text-align:center}._3yCU .h4{margin-bottom:0;text-align:center;display:block}._3yCU .h3b{margin-top:0;text-align:center}._3yCU .btn{width:100%}._3yCU p{margin:.8rem auto 0}._3yn8{max-width:300px;font-weight:400}@media (min-width:36em){._3yn8{min-height:4.8rem}}._3cfc{width:100%}.Mv-x{display:block;text-align:center}._3fDk{margin:.8rem 0 0;display:flex;justify-content:center;flex-wrap:wrap}._3gAK{width:100%;margin:.8rem 0 0}._3gAK td:first-child{padding:0 1rem 0 0}._3gAK td:nth-child(2){width:140px;vertical-align:top;text-align:right}.IF9U,._2avy{width:100%}._2avy{margin:.8rem 0}html[dir=rtl] ._3gAK td:first-child{padding:0 0 0 1rem}html[dir=rtl] ._3gAK td:nth-child(2){text-align:left}", ""]);
// Exports
exports.locals = {
	"wrapp": "_3yCU",
	"subheader": "_3yn8",
	"content": "_3cfc",
	"imgWrapper": "Mv-x",
	"iconsWrapp": "_3fDk",
	"table": "_3gAK",
	"btnWrapp": "IF9U",
	"link": "_2avy"
};
module.exports = exports;
